export default "__VITE_ASSET__DbKP$zcm__"